// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-5bb57b0b] .el-scrollbar__wrap{overflow-x:hidden}[data-v-5bb57b0b] .el-radio{margin-left:6px}[data-v-5bb57b0b] .el-radio .el-radio__label{display:none}", ""]);
// Exports
module.exports = exports;
